/**
 * Источник новостей через настоящие ручки из `contract.ts`. Mock
 * (`mocks/store.ts`) — только при `VITE_NEWS_MOCK=true`.
 */
import type { ApiClient } from '../client'
import type { NewsDto, NewsMediaDto, NewsPage, PublicNewsDto, PublicNewsItemDto } from './contract'
import type { NewsBackend, NewsQuery } from './mocks/store'

const params = (query: NewsQuery = {}) => ({
  query: {
    page: query.page,
    page_size: query.pageSize,
    q: query.q || undefined,
  },
})

export function createHttpNewsBackend(api: ApiClient): NewsBackend {
  return {
    list: (query) => api.get<NewsPage<NewsDto>>('/admin/news', params(query)),
    get: (id) => api.get<NewsDto>(`/admin/news/${id}`),
    create: (input) => api.post<NewsDto>('/admin/news', input),
    update: (id, input) => api.put<NewsDto>(`/admin/news/${id}`, input),
    remove: async (id) => {
      await api.del<unknown>(`/admin/news/${id}`)
    },
    upload: (file) => {
      const form = new FormData()
      form.append('file', file)
      return api.post<NewsMediaDto>('/admin/news/media', form)
    },
    published: (query) => api.get<NewsPage<PublicNewsItemDto>>('/news', params(query)),
    publishedOne: (id) => api.get<PublicNewsDto>(`/news/${id}`),
  }
}
